import { ActionTypes } from './actionTypes';

export const clearDisplayMessageAndError = () => {
  return { type: ActionTypes.CLEAR_DISPLAY_MESSAGE_AND_ERROR  };
}
